import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { money } from "@/components/status";
import { Users, Briefcase, Wallet, Scale, ShieldCheck, UserCheck } from "lucide-react";

function Stat({ icon: Icon, label, value, accent }) {
  return (
    <div className={`border border-border rounded-md p-5 ${accent ? "bg-sapphire text-white" : "bg-white"}`} data-testid={`admin-stat-${label.toLowerCase().replace(/\s/g, "-")}`}>
      <div className="flex items-center justify-between">
        <span className={`text-xs uppercase tracking-[0.2em] ${accent ? "text-white/60" : "text-muted-foreground"}`}>{label}</span>
        <Icon className={`w-4 h-4 ${accent ? "text-white" : "text-ocean"}`} />
      </div>
      <div className={`font-heading font-black text-3xl mt-2 ${accent ? "text-white" : "text-sapphire"}`}>{value}</div>
    </div>
  );
}

export default function AdminOverview() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="admin-overview">
      <div>
        <h1 className="font-heading font-black text-3xl tracking-tight text-sapphire">Platform Overview</h1>
        <p className="text-muted-foreground text-sm mt-1">System-wide metrics and health.</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={Users} label="Total Users" value={s.users || 0} />
        <Stat icon={UserCheck} label="Cleaners" value={s.cleaners || 0} />
        <Stat icon={Users} label="Hosts" value={s.pms || 0} />
        <Stat icon={Briefcase} label="Total Jobs" value={s.jobs || 0} />
        <Stat icon={Briefcase} label="Active Jobs" value={s.active_jobs || 0} />
        <Stat icon={Wallet} label="Platform Revenue" value={money(s.platform_revenue)} accent />
        <Stat icon={Wallet} label="Paid to Cleaners" value={money(s.payouts_total)} />
        <Stat icon={Scale} label="Open Disputes" value={s.open_disputes || 0} />
        <Stat icon={ShieldCheck} label="BG Pending" value={s.pending_bg_checks || 0} />
      </div>
    </div>
  );
}
